import Navbar from "../headers_footer/navbar";
import Header from "../headers_footer/header";
import './ReturnPolicy.css';

const ReturnPolicy = () => {

return (

<div>

<Navbar></Navbar>

<div className="return_flex_">

<div>

<h2 className="return_tag">RETURN & REFUND POLICY</h2>

<p>Our customer service team will be happy 
to assist you for eligible returns. If you 
received the product and wish to exchange it 
for another item, or you received a damaged 
product, directions are provided below. Only 
products purchased on www.winsome-bloom.shop 
can be returned.
</p>

<h2>SHIPPING</h2>

<p>
{" "}
You may be required to register with the Site. 
You agree to keep your password confidential and 
will be responsible for all use of your account and 
password. We reserve the right to remove, reclaim, or 
change a username you select if we determine, in our sole 
discretion, that such username is inappropriate, obscene, 
or otherwise objectionable.
{" "}
</p>

<h2>CASH ON DELIVERY</h2>

<p>
{" "}
You may be required to register with the Site. 
You agree to keep your password confidential and 
will be responsible for all use of your account and 
password. We reserve the right to remove, reclaim, or 
change a username you select if we determine, in our sole 
discretion, that such username is inappropriate, obscene, 
or otherwise objectionable.
{" "}
</p>

<h2>CANCELLATION</h2>

<p>
{" "}
You may be required to register with the Site. 
You agree to keep your password confidential and 
will be responsible for all use of your account and 
password. We reserve the right to remove, reclaim, or 
change a username you select if we determine, in our sole 
discretion, that such username is inappropriate, obscene, 
or otherwise objectionable.
{" "}
</p>

</div>

</div>

<Header></Header>

</div>

)

}

export default ReturnPolicy;
